import { Languages } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const TranslationsIcon = createNavigationLucideIcon(Languages);
